import React from "react";
import ReactDOM from "react-dom/client";
import App from "./consultancy-dashboard";

// The dashboard component (App) handles its own session state, login screen,
// and password recovery flow internally - see the auth useEffect and
// LoginScreen/SetPasswordScreen components inside consultancy-dashboard.jsx.
// This file previously wrapped App in a SECOND, separate auth layer that
// rendered an old Login.jsx with no password-reset capability at all, which
// silently intercepted every session check before App's own logic ever ran.
// That's why password reset appeared broken despite being fixed inside App -
// the fixed code was never being reached.

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);